      // Module for handling creation of color swatch or image URL for given product image and type
      var ProductSwatchController = (function () {
        const whitelistedCategories = ['Tilbehør', 'Bukser & shorts', 'Sko', 'Vesker', 'Smykker', 'Undertøy'];
        function isWhitelistedCategory(productType) {
          return whitelistedCategories.includes(productType);
        }

        // Catalog colour-name → hex. Norwegian primary, English aliases where
        // the catalog uses them. `null` = sentinel for "not a single colour"
        // (multi/pattern) — caller falls through to the image-bg path.
        const COLOR_HEX = {
          'Sort':         '#1a1a1a',
          'Black':        '#1a1a1a',
          'Hvit':         '#ffffff',
          'White':        '#ffffff',
          'Off-white':    '#f5f1e8',
          'Off white':    '#f5f1e8',
          'Eggshell':     '#f0ead6',
          'Krem':         '#f0e8d8',
          'Cream':        '#f0e8d8',
          'Vanilje':      '#f3e9d2',
          'Vanilla':      '#f3e9d2',
          'Grå':          '#9a9a9a',
          'Grey':         '#9a9a9a',
          'Gray':         '#9a9a9a',
          'Lys grå':      '#c0c0c0',
          'Mørk grå':     '#5a5a5a',
          'Sølvgrå':      '#c0c4c8',
          'Antrasitt':    '#383838',
          'Anthracite':   '#383838',
          'Charcoal':     '#36454f',

          'Beige':        '#d4c0a0',
          'Sand':         '#c2b280',
          'Camel':        '#c19a6b',
          'Tan':          '#d2b48c',
          'Khaki':        '#b8a07a',
          'Taupe':        '#8b7d6b',
          'Champagne':    '#f0e6c0',
          'Nude':         '#e3bca6',
          'Tobakk':       '#6c5b3e',
          'Tobacco':      '#6c5b3e',
          'Mocca':        '#6f4e37',
          'Mocha':        '#6f4e37',
          'Espresso':     '#4a2c20',
          'Sjokolade':    '#5a3a22',
          'Chocolate':    '#5a3a22',
          'Karamell':     '#af6e2c',
          'Caramel':      '#af6e2c',
          'Cognac':       '#9b4f1a',
          'Rust':         '#b7410e',

          'Brun':         '#6b4423',
          'Brown':        '#6b4423',
          'Lys brun':     '#a87c5a',
          'Mørk brun':    '#3e2418',

          'Rød':          '#c43b3b',
          'Red':          '#c43b3b',
          'Mørk rød':     '#8a1f1f',
          'Bordeaux':     '#5e1a26',
          'Burgundy':     '#5e1a26',
          'Vinrød':       '#5e1a26',
          'Korall':       '#f88379',
          'Coral':        '#f88379',
          'Lakserød':     '#f88379',
          'Salmon':       '#f88379',
          'Aprikos':      '#fbceb1',
          'Apricot':      '#fbceb1',
          'Fuksia':       '#c4257f',
          'Fuchsia':      '#c4257f',
          'Magenta':      '#c4257f',
          'Rosa':         '#e8b4c1',
          'Pink':         '#e8b4c1',
          'Lys rosa':     '#f3d1da',
          'Light pink':   '#f3d1da',
          'Mørk rosa':    '#b86a83',
          'Pudderrosa':   '#f4d6da',
          'Powder pink':  '#f4d6da',

          'Lilla':        '#7a3a8a',
          'Purple':       '#7a3a8a',
          'Violet':       '#7a3a8a',
          'Lys lilla':    '#b993c5',
          'Mørk lilla':   '#4a1f5a',
          'Plomme':       '#602a5a',
          'Plum':         '#602a5a',
          'Aubergine':    '#3d2645',
          'Lavendel':     '#b9a6d8',
          'Lavender':     '#b9a6d8',

          'Blå':          '#4f6f9c',
          'Blue':         '#4f6f9c',
          'Lys blå':      '#a6c8d8',
          'Light blue':   '#a6c8d8',
          'Mørk blå':     '#2a3f60',
          'Marineblå':    '#1c2a44',
          'Marine':       '#1c2a44',
          'Navy':         '#1c2a44',
          'Cobalt':       '#2049a8',
          'Kobolt':       '#2049a8',
          'Turkis':       '#3aa9b5',
          'Turquoise':    '#3aa9b5',
          'Petrol':       '#1f5560',
          'Petroleum':    '#1f5560',
          'Denim':        '#4a6b8a',
          'Himmelblå':    '#87ceeb',
          'Sky blue':     '#87ceeb',

          'Grønn':        '#5a8e6a',
          'Green':        '#5a8e6a',
          'Lys grønn':    '#a8c8a0',
          'Mørk grønn':   '#234a30',
          'Olivengrønn':  '#6b6a2c',
          'Oliven':       '#6b6a2c',
          'Olive':        '#6b6a2c',
          'Skoggrønn':    '#2f4f3f',
          'Forest green': '#2f4f3f',
          'Mintgrønn':    '#98d6b4',
          'Mint':         '#98d6b4',
          'Limegrønn':    '#a8d63a',
          'Lime':         '#a8d63a',
          'Sjøgrønn':     '#2e8b8b',
          'Sea green':    '#2e8b8b',
          'Salviegrønn':  '#88a888',
          'Sage':         '#88a888',
          'Kakigrønn':    '#6b7d4a',
          'Smaragd':      '#197e4d',
          'Emerald':      '#197e4d',

          'Gul':          '#e8c863',
          'Yellow':       '#e8c863',
          'Lys gul':      '#f3deaa',
          'Mørk gul':     '#b89a3a',
          'Sennep':       '#b8923a',
          'Mustard':      '#b8923a',
          'Okergul':      '#cc7722',
          'Oker':         '#cc7722',
          'Ochre':        '#cc7722',

          'Oransje':      '#e8884a',
          'Orange':       '#e8884a',
          'Mørk oransje': '#b85a26',
          'Brent oransje':'#cc4e1a',

          'Gull':         '#d4af37',
          'Gold':         '#d4af37',
          'Sølv':         '#c0c0c0',
          'Silver':       '#c0c0c0',
          'Bronse':       '#a0703a',
          'Bronze':       '#a0703a',
          'Roségull':     '#c4807a',
          'Rose gold':    '#c4807a',
          'Kobber':       '#b87333',
          'Copper':       '#b87333',
          'Platina':      '#cccac8',
          'Platinum':     '#cccac8',
          'Perle':        '#f0ead6',
          'Pearl':        '#f0ead6',

          'Flerfarget':   null,
          'Multifarget':  null,
          'Multi':        null,
          'Mønstret':     null,
          'Patterned':    null,
          'Stripet':      null,
          'Striped':      null,
          'Print':        null,
        };

        // Neutral grey for swatches whose colour name is missing from the
        // map. Visible (not white-on-white), reads as "no colour data".
        const SWATCH_FALLBACK_HEX = '#cccccc';

        function resolveColorHex(name) {
          if (!name) return SWATCH_FALLBACK_HEX;
          if (Object.prototype.hasOwnProperty.call(COLOR_HEX, name)) {
            return COLOR_HEX[name];
          }
          const parts = String(name).trim().split(/\s+/);
          if (parts.length > 1) {
            const last = parts[parts.length - 1];
            if (Object.prototype.hasOwnProperty.call(COLOR_HEX, last)) {
              return COLOR_HEX[last];
            }
            const lastLower = last.toLowerCase();
            for (const key of Object.keys(COLOR_HEX)) {
              if (key.toLowerCase() === lastLower) return COLOR_HEX[key];
            }
          }
          return SWATCH_FALLBACK_HEX;
        }

        async function getColorTags(tags) {
          const tagsArray = tags.replace(/^\[|\]$/g, '').split(/\s*,\s*/);
          let result = {
            COLOR_MATCHED: false,
            SWATCH_IMAGE_COLORS: [],
            SWATCH_COLOR: null,
            COLOR: null,
            SWATCH_OVERRIDE: null,
            PATTERN: null,
          };

          tagsArray.forEach((tag) => {
            if (tag === 'COLOR_MATCHED') {
              result.COLOR_MATCHED = true;
            } else if (tag.startsWith('SWATCH_IMAGE_COLORS:')) {
              let hexPart = tag.split(':')[1];
              if (hexPart) {
                result.SWATCH_IMAGE_COLORS = hexPart.split('-');
              }
            } else if (tag.startsWith('SWATCH_COLOR:')) {
              let hexPart = tag.split(':')[1];
              if (hexPart && /^#[0-9A-Fa-f]{6}$/.test(hexPart)) {
                result.SWATCH_COLOR = hexPart;
              }
            } else if (tag.startsWith('COLOR:')) {
              result.COLOR = tag.split(':')[1];
            } else if (tag.startsWith('SWATCH_OVERRIDE:')) {
              result.SWATCH_OVERRIDE = tag.split(':')[1];
            } else if (tag.startsWith('PATTERN:')) {
              result.PATTERN = tag.split(':')[1];
            }
          });

          return result;
        }

        async function fetchProductData(url) {
          try {
            const response = await fetch(`${url}.json`);
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const data = await response.json();
            return data.product;
          } catch (error) {
            console.error('Error fetching product data:', error);
            return null;
          }
        }

        async function getProductSwatch(imageUrl, productType, tags = null) {
          const swatchTagData = await getColorTags(tags);
          if (!imageUrl || typeof imageUrl !== 'string') {
            console.error('Invalid image URL. Expected a string.');
            return null;
          }

          if (!productType || typeof productType !== 'string') {
            console.error('Invalid product type. Expected a string.');
            return null;
          }
          if (swatchTagData.SWATCH_OVERRIDE) {
            return [swatchTagData.SWATCH_OVERRIDE];
          }
          if (isWhitelistedCategory(productType) || swatchTagData.PATTERN === 'Ensfarget') {
            if (swatchTagData.COLOR_MATCHED) {
              return [swatchTagData.SWATCH_COLOR];
            }
            if (swatchTagData.COLOR) {
              const hex = resolveColorHex(swatchTagData.COLOR);
              if (hex) return [hex];
            } else {
              return [SWATCH_FALLBACK_HEX];
            }
          }
          return imageUrl;
        }

        async function getProductStyleCss(imageUrl, productType, gradientType = 'diagonal', tags = null) {
          const swatch = await this.getProductSwatch(imageUrl, productType, tags);
          if (swatch === imageUrl) {
            // make sure imageUrl has width and height query params
            if (!imageUrl.includes("width")) {
               imageUrl += `&width=100&height=100`;
            }
            return `background: url(${imageUrl}) center center / 450% no-repeat;`;
          } else {
            if (Array.isArray(swatch) && swatch.length === 1) {
              return `background: ${swatch[0]};`;
            }
            const gradientColors = swatch.map((color) => `${color}`).join(',');

            if (gradientType === 'linear') {
              return `background: linear-gradient(to right, ${gradientColors});`;
            }

            if (gradientType === 'radial') {
              return `background: radial-gradient(circle, ${gradientColors});`;
            }

            if (gradientType === 'conic') {
              return `background: conic-gradient(from 0deg, ${gradientColors});`;
            }

            if (gradientType === 'diagonal') {
              return `background: linear-gradient(45deg, ${gradientColors});`;
            }
          }
        }

        function getLinkStyleOrImage(imageUrl, productType) {
          return imageUrl;
        }

        let isSwatchesAdjusting = false;
        let adjustSwatchesQueue = [];
        window.adjustSwatchesQueue = adjustSwatchesQueue;
        window.isSwatchesAdjusting = isSwatchesAdjusting;
        function adjustSwatches(gradientType = 'diagonal') {
          if (isSwatchesAdjusting) {
            adjustSwatchesQueue = [gradientType];
            return;
          }

          isSwatchesAdjusting = true;

          // Use requestAnimationFrame for better performance
          requestAnimationFrame(() => {
            const selector = `.ns-product-top__colors-list > a:not([data-swatch-style]):not(.ns-extra-swatch)`;
            const allSwatches = document.querySelectorAll(selector);
            const swatchContainers = document.querySelectorAll('.ns-product-top__colors-list, .vertex-colors-list');
            swatchContainers.forEach((container) => {
              const swatchesInContainer = container.querySelectorAll('a[data-swatch-product-tags]');
              const hasCharmsSwatch = Array.from(swatchesInContainer).some((swatch) => {
                const tags = swatch.getAttribute('data-swatch-product-tags');
                return tags && tags.includes('KATEGORI:Charms');
              });

              if (hasCharmsSwatch) {
                container.style.display = 'none';
              }
            });

            const swatches = Array.from(allSwatches).filter((swatch) => {
              const tags = swatch.getAttribute('data-swatch-product-tags');
              if (tags && tags.includes('KATEGORI:Charms')) {
                return false;
              }
              return true;
            });

            // Process swatches in batches to avoid blocking the main thread
            const batchSize = 5;
            let index = 0;

            function processBatch() {
              const end = Math.min(index + batchSize, swatches.length);

              const promises = [];
              for (let i = index; i < end; i++) {
                const swatch = swatches[i];
                const productType = swatch.getAttribute('data-swatch-product-type');
                const tags = swatch.getAttribute('data-swatch-product-tags');
                const imageUrl = swatch.getAttribute('data-swatch-image-uri');

                promises.push(
                  ProductSwatchController.getProductStyleCss(imageUrl, productType, gradientType, tags).then(
                    (styleCss) => {
                      swatch.setAttribute('data-swatch-style', styleCss);
                      swatch.style = styleCss;
                    }
                  )
                );
              }

              Promise.all(promises).then(() => {
                index = end;
                if (index < swatches.length) {
                  // Process next batch in the next animation frame
                  requestAnimationFrame(processBatch);
                } else {
                  isSwatchesAdjusting = false;

                  // Process any queued adjustments
                  if (adjustSwatchesQueue.length > 0) {
                    const nextGradientType = adjustSwatchesQueue.shift();
                    adjustSwatches(nextGradientType);
                  }
                }
              });
            }
            processBatch();
          });
        }

        return {
          whitelistedCategories: whitelistedCategories,
          getProductSwatch: getProductSwatch,
          getProductStyleCss: getProductStyleCss,
          getLinkStyleOrImage: getLinkStyleOrImage,
          adjustSwatches: adjustSwatches,
        };
      })();

      window.ProductSwatchController = ProductSwatchController;
    
